import { render, staticRenderFns } from "./Activity1_1.vue?vue&type=template&id=ff3d0b16&scoped=true&"
import script from "./Activity1_1.vue?vue&type=script&lang=js&"
export * from "./Activity1_1.vue?vue&type=script&lang=js&"
import style0 from "./Activity1_1.vue?vue&type=style&index=0&id=ff3d0b16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3d0b16",
  null
  
)

export default component.exports